export default __webpack_public_path__ + "static/media/coach_operators_city_map.0ba124a9.png";